// extracted by mini-css-extract-plugin
module.exports = {"var-in-desktop":"min-width: 768px","varInDesktop":"min-width: 768px","membership-form":"membership-form--a8e40","membershipForm":"membership-form--a8e40"};